var _circle, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWorkflowStepLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 8.5,
    fill: "#A0A9B4",
    stroke: "#F9FCFB",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_513_6995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.125 9.125H6.875C6.46079 9.125 6.125 9.46079 6.125 9.875V12.5C6.125 12.9142 6.46079 13.25 6.875 13.25H12.125C12.5392 13.25 12.875 12.9142 12.875 12.5V9.875C12.875 9.46079 12.5392 9.125 12.125 9.125Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.625 9.125V7.625C7.625 7.12772 7.82254 6.65081 8.17417 6.29917C8.52581 5.94754 9.00272 5.75 9.5 5.75C9.99728 5.75 10.4742 5.94754 10.8258 6.29917C11.1775 6.65081 11.375 7.12772 11.375 7.625V9.125",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_513_6995"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflowStepLocked);
export default __webpack_public_path__ + "static/media/workflow-step-locked.fd8d825519a5c3aea7e4598d214c7b99.svg";
export { ForwardRef as ReactComponent };